import { Component, OnInit,Inject } from '@angular/core';
import { ShopifyComponent } from '../shopify.component';
import {MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-popup-connect-shopify',
  templateUrl: './popup-connect-shopify.component.html',
  styleUrls: ['./popup-connect-shopify.component.css']
})
export class PopupConnectShopifyComponent implements OnInit {
  body: any;
  constructor(public DialogRef: MatDialogRef<ShopifyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.body=data.body;
  }
  ngOnInit() {
    this.DialogRef.updateSize('50%', '50vh');

  }
  onCloseClick() {
    this.DialogRef.close();
  }
}
